<template>
  <div class="flex h-full max-h-full min-h-0 flex-col">
    <div class="shrink-0 px-4 pt-2">
      <BaseSimpleTab :tabs="tabs" />
    </div>
    <div class="flex min-h-0 flex-1 flex-col">
      <RouterView />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheInvoicingSettingsView',
  data() {
    return {
      tabs: [
        {
          label: this.$t('global.general'),
          icon: '',
          routeName: 'settings_list_invoicing_route'
        },
        {
          label: this.$t('global.accounting_code'),
          icon: '',
          routeName: 'settings_accounting_code_route'
        }
      ]
    }
  }
}
</script>
